import KeyIcon from '@mui/icons-material/Key';
import { LoadingButton } from '@mui/lab';
import { Button, Stack, TextField, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import PropTypes from 'prop-types';
import React from 'react';

const GenerateKey = ({
  inputName,
  setInputName,
  handleGenerateApiKey,
  loading,
  setIsEnableCreate
}) => {
  const theme = useTheme();
  return (
    <Stack spacing={2} alignItems="center">
      <Typography color={theme.palette.grey[600]}>
        Para generar tu API KEY, requerimos que nos proporciones un
        identificador.
      </Typography>
      <Stack direction="row" spacing={2}>
        <TextField
          label="Ej. Primer Api Key"
          helperText="Introduce un nombre para identificar tu API KEY"
          value={inputName}
          onChange={({ target: { value } }) => setInputName(value)}
        />
        <Stack direction="row" spacing={2}>
          <LoadingButton
            variant="contained"
            size="large"
            startIcon={<KeyIcon />}
            onClick={handleGenerateApiKey}
            loading={loading}
          >
            Generar
          </LoadingButton>
          <Button
            variant="outlined"
            color="error"
            size="large"
            onClick={() => setIsEnableCreate(false)}
          >
            Cancelar
          </Button>
        </Stack>
      </Stack>
    </Stack>
  );
};

GenerateKey.propTypes = {
  inputName: PropTypes.string,
  setInputName: PropTypes.func,
  handleGenerateApiKey: PropTypes.func,
  loading: PropTypes.bool,
  setIsEnableCreate: PropTypes.func
};

export default GenerateKey;
